import { tools, storage } from '../utils/tools'

import _getUserInfo from './apis/getUserInfo'
import jsCookie from 'js-cookie';

import login from './apis/login'
import { EventEmitter } from '../EventEmitter'


const redirectURL = ''

/**
 * @class Auth
 * @classdesc 权限验证
 */
export default class Auth extends EventEmitter {
    constructor(proc) {
        super()
        this.proc = proc;
        this.$root = proc.$root;
        this.$data = proc.data;
        this.initLogin()
        window.addEventListener('message', (e) => {
            let msg = e.data;
            let token = msg.token;
            if (token) {
                jsCookie.set('token', token);
                this.proc.setData({
                    token: token
                })
                this.initLogin();
            }
        })
        window.parent.postMessage({
            type: 'auth',
            success: true,
            msg: '权限验证加载完成'
        }, '*')
    }
    // 重定向地址，用于用户登陆定向
    set redirectURL(val){
        sessionStorage.setItem('redirectURL', val)
    }

    get redirectURL(){
        return sessionStorage.getItem('redirectURL')
    }

    async initLogin() {
        let token = jsCookie.get('token') || this.proc.data.token

        if (token) {
            this.proc.setData({
                token: token
            })
            this.isLogined = true;
            this.proc.emit('login', this.isLogined)
            let userinfo = storage.get('userinfo') || null;
            if (!userinfo) {
                this.getUserInfo()
            } else {
                this.userInfo = userinfo;
            }
        }
    }

    /**
     * 请求获取用户信息
     * @returns {Promise<void>}
     */
    async getUserInfo() {
        let res = await _getUserInfo()
        if (res) {
            this.userInfo = res;
        }
        return res;
    }



    /**
     * 读取用户信息
     */
    get userInfo() {
        let userinfo = this.proc.data.userinfo || storage.get('userinfo');
        if (!userinfo) {
            this.getUserInfo()
            return null;
        }
        return userinfo
    }
    /**
     * 设置用户信息
     */
    set userInfo(userinfo) {
        this.proc.emit('userinfo', userinfo)
        this.proc.setData({
            userinfo: userinfo
        })
    }

    /**
     * 选择的项目
     */
    set selectProject(val) {
        this.proc.setData({
            selectProject: val
        })
    }
    get selectProject() {
        return this.proc.data.selectProject;
    }
    /**
     * 获取设备信息
     */
    get device() {
        let device = this.proc.data.device;
        if (!device) {
            device = storage.get('device')
        }
        return device
    }

    set device(value) {
        this.proc.emit('changeDevice', value)
        storage.set("device", value);
        this.proc.setData({
            device: value
        })
    }



    set isLogined(val) {
        this.proc.data.isLogined = val
        this.proc.emit('login', val)
    }
    /**
     * 获取登陆状态
     */
    get isLogined() {
        let token = jsCookie.get('token') || this.proc.data.token
        if (token) {
            return this.proc.data.isLogined
        }
        return false;
    }

    /**
     * 验证是否是管理员
     * @returns {Promise<boolean>}
     */
    isAdmin() {
        return this.userInfo?.isAdmin || false;
    }

    /**
     * 提交登陆信息
     * @param {string} account 
     * @param {string} password 
     * @returns {Promise<void>}
     */
    submit(account, password) {
        return new Promise((resolve, reject) => {
            login(account, password)
                .then((login) => {
                    if (login.success) {
                        this.isLogined = true;
                        this.initLogin()
                    }
                    resolve(login)
                }).catch((e) => {
                    reject(e)
                })
        })
    }

    /**
     * 退出登陆
     */
    loginout() {
        try {
            this.proc.data.token = null;
            this.proc.data.userinfo = null;
            this.isLogined = false;
            jsCookie.remove('token');
            storage.remove('device');
            storage.remove('userinfo');
            storage.remove('token');
            return true;
        } catch (error) {
            return false;
        }

        // location.reload();
    }

}